/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgModelChangeMgmt = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M12.53 2.152 12 1.821l-.53.331-8 5-.47.294v9.108l.47.294 8 5 .53.331.53-.331 2-1.25-1.06-1.696-.47.294v-5.642l6-3.75V12.5h2V7.446l-.47-.294zM11 13.554v5.642l-6-3.75V9.804zm1-1.733L5.887 8 12 4.178 18.113 8zM16 17a2 2 0 0 1 3.333-1.49l1.334-1.491A3.999 3.999 0 0 0 14 17a4 4 0 0 0 6.667 2.981l-1.334-1.49A1.998 1.998 0 0 1 16 17zm6-2v4l-3-2z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgModelChangeMgmt as ModelChangeMgmt };
